function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m141 10.3-5.8 14.8c-.2.5-.3.9-.3 1.2 0 .6.5 1.1 1.4 1.4h-7.5c1.4-.6 1.9-1 2.4-2.2l9.8-22 9.8 22c.5 1.2.9 1.6 2.4 2.2h-7.5c1-.4 1.5-.8 1.5-1.4 0-.3-.1-.7-.3-1.2z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m16.5 5.9c-5.5 0-9.1 3.8-9.1 9.7s3.4 9.8 9 9.8c5.2 0 7.7-3.6 7.7-3.6l-.4 4.9c-3.7 1-5.3 1.3-7.9 1.3-7.9 0-12.7-5.4-12.7-12.2 0-7.1 5.3-12.2 12.6-12.2 3.3 0 5.3.6 6.3.6.6 0 .9-.2 1.3-.8v5.6s-1.7-3.1-6.8-3.1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m45.5 25.4c-4.3 0-7.7-4.3-7.7-9.8s3.4-9.5 8-9.5c4.7 0 7.7 3.8 7.7 9.6 0 5.7-3.4 9.7-8 9.7m.1-21.8c-7 0-11.8 4.9-11.8 12s5.2 12.4 11.8 12.4c6.7 0 11.7-5.4 11.7-12.4.1-7.1-4.7-12-11.7-12"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m85.9 20.7v-12.7c0-2.5-.2-3-2-3.6h7c-1.6.8-1.7 1.1-1.7 3.6v20.2l-18-17.1v13.2c0 2.3.3 2.7 2.2 3.4h-7.5c1.4-.5 2-1.1 2-3.4v-20.7z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m117.4 10.2c0 4.9-4.2 5.6-4.2 5.6l4.5 5.5c2 2.5 4.1 5.1 6.1 6.4h-5.1l-9.9-12.2c2.4-.5 4.6-1.9 4.6-4.7 0-2.2-1.8-4-4.4-4-1.3 0-2.2.3-2.2.3v15.7c0 1.6 0 4.3 2.2 4.9h-.6-6.5-.6c2.3-.6 2.1-3.4 2.1-4.9v-13.3c0-1.6.3-4.4-1.8-5h8.3c3.2.1 7.5 1.2 7.5 5.7"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m168.6 25.1h-1.7c-1.4 0-1.9-.6-1.9-2.2v-16h3.4c5.8 0 9.4 3.9 9.4 9.4-.1 5.4-3.9 8.8-9.2 8.8m13.2-8.9c0-7.9-5.9-11.6-13.5-11.6h-8.8c2 .7 2.1 1.2 2.1 3.5v16.4c0 2.3-.5 2.9-2.1 3.4h7.5c9.1-.1 14.8-4.3 14.8-11.7"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m26.3 44.7.1-.3c0-1.6 0-1.8 0-2.2 0-.3-.1-.5-.4-.6-.1 0-.3 0-.4 0s-.2 0-.2-.1.1-.1.2-.1h1.5 1.3c.1 0 .2 0 .2.1s-.1.1-.2.1-.2 0-.3 0c-.3 0-.4.2-.4.6v2.2 1.8c0 .9 0 1.7.1 2.2 0 .3.1.5.4.6h.5c.1 0 .2 0 .2.1s-.1.1-.2.1c-.7 0-1.3 0-1.6 0-.2 0-.9 0-1.3 0-.1 0-.2 0-.2-.1s0-.1.2-.1h.4c.2 0 .3-.3.3-.6 0-.4 0-1.2 0-2.2v-.9s0-.1-.1-.1h-3.9s-.1 0-.1.1v.9 2.2c0 .3.1.5.4.6h.5c.1 0 .2 0 .2.1s-.1.1-.2.1c-.7 0-1.3 0-1.6 0-.2 0-.9 0-1.3 0-.1 0-.2 0-.2-.1s0-.1.2-.1h.4c.2 0 .3-.3.3-.6-.1-.4-.1-1.2-.1-2.1v-1.8c0-1.6 0-1.8 0-2.2 0-.3-.1-.5-.4-.6-.1 0-.3 0-.4 0s-.2 0-.2-.1.1-.1.2-.1h1.5 1.3c.1 0 .2 0 .2.1s-.1.1-.2.1-.2 0-.3 0c-.3 0-.4.2-.4.6v2.2.2c0 .1 0 .1.1.1h3.9z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m35.9 48.9c-2 0-3.1-1.7-3.1-3.8 0-2.6 1.3-3.2 2.5-3.2 1.7 0 3 1.4 3 3.7 0 2.9-1.7 3.3-2.4 3.3m-.3-7.6c-3.1 0-4.2 2.3-4.2 4 0 1.8 1.2 4 4.1 4 2.6 0 4.2-1.9 4.2-4.2s-1.6-3.8-4.1-3.8"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m44.7 42.1h-1.5c-.6 0-.8.1-1 .3-.1.2-.2.3-.2.4s0 .1-.1.1-.1-.1-.1-.2c0-.2.2-1.1.2-1.2s.1-.2.1-.2c.1 0 .2.1.4.1.3 0 .7.1 1 .1h4.1c.3 0 .6 0 .7-.1.2 0 .2-.1.3-.1s.1.1.1.2v1.2c0 .1 0 .2-.1.2s-.1-.1-.1-.2v-.1c0-.3-.3-.6-1.2-.6h-1.3v4.2 2.2c0 .3.1.5.4.6h.5c.1 0 .2 0 .2.1s-.1.1-.2.1c-.7 0-1.3 0-1.6 0-.2 0-.9 0-1.3 0-.1 0-.2 0-.2-.1s0-.1.2-.1h.4c.2 0 .3-.3.3-.6.1-.4.1-1.2.1-2.2v-4.1z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m52.9 44.5c0-1.6 0-1.8 0-2.2 0-.3-.1-.5-.4-.6-.1 0-.3 0-.4 0s-.2 0-.2-.1.1-.1.2-.1h.8.6 2.6c.2 0 .4 0 .4-.1h.2s.1 0 .1.1-.1.2-.1.7c0 .1 0 .6-.1.7 0 .1 0 .1-.1.1s-.1-.1-.1-.1c0-.1 0-.2-.1-.4s-.2-.3-.7-.4c-.2 0-1.2 0-1.5 0 0 0-.1 0-.1.1v2.6c0 .1 0 .1.1.1h1.6c.2 0 .4-.1.5-.2s.1-.1.2-.1c0 0 .1 0 .1.1s0 .2-.1.7v.7c0 .1 0 .2-.1.2s-.1 0-.1-.1 0-.2 0-.4c-.1-.2-.2-.4-.6-.4-.2 0-1.2 0-1.5 0 0 0-.1 0-.1.1v.8 1.6c0 .7.2.9 1.2.9.3 0 .7 0 1-.1s.4-.3.5-.8c0-.1 0-.2.1-.2s.1.1.1.2c0 .2-.1.9-.1 1.1-.1.3-.2.3-.5.3-.8 0-1.3 0-1.8 0-.4 0-.8 0-1.1 0-.1 0-.3 0-.6 0-.2 0-.5 0-.7 0-.1 0-.2 0-.2-.1s0-.1.2-.1h.4c.2 0 .3-.3.3-.6.1-.4.1-1.2.1-2.2z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m62.9 46.3c0 1.3 0 2 .2 2.2s.4.2 1.2.2c.5 0 .9 0 1.2-.3.1-.1.2-.4.3-.6 0-.1 0-.1.1-.1s.1 0 .1.2c0 .1-.1.9-.2 1.2-.1.2-.1.3-.6.3-.7 0-1.3 0-1.7 0-.5 0-.8 0-1.3 0-.1 0-.3 0-.6 0-.2 0-.5 0-.7 0-.1 0-.2 0-.2-.1s0-.1.2-.1h.4c.2 0 .3-.3.3-.6.1-.4.1-1.2.1-2.2v-1.8c0-1.6 0-1.8 0-2.2 0-.3-.1-.5-.4-.6-.1 0-.2 0-.3 0s-.2 0-.2-.1.1-.1.2-.1h1.4 1.4c.1 0 .2 0 .2.1s-.1.1-.2.1-.3 0-.4 0c-.3 0-.4.2-.4.6v2.2 1.7z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m69.5 49.1c-.2-.1-.2-.1-.2-.3 0-.6 0-1.2.1-1.3 0-.2 0-.3.1-.3s.1.1.1.2 0 .3.1.5c.2.8.8 1 1.5 1 .9 0 1.4-.6 1.4-1.2 0-.5-.2-1-1-1.6l-.6-.4c-1.1-.9-1.5-1.6-1.5-2.4 0-1.1.9-1.9 2.4-1.9.7 0 1.1.1 1.4.2.1 0 .1.1.1.1v1.2c0 .2 0 .3-.1.3s-.1-.1-.1-.2-.1-.4-.3-.7c-.2-.2-.4-.5-1.1-.5-.8 0-1.2.4-1.2 1.1 0 .5.2.8 1.1 1.5l.3.2c1.2.9 1.7 1.6 1.7 2.6 0 .6-.2 1.3-1 1.8-.5.3-1.1.4-1.6.4-.7 0-1.2-.1-1.6-.3"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m85.7 48.7c-1.1 0-2-.8-2-2.1 0-.8.4-1.3.7-1.6.2.3.8 1 1.1 1.3s1.3 1.2 1.8 1.8c-.2.2-.8.6-1.6.6m5.4.3c-.2 0-.8-.2-1.1-.4s-.7-.4-1.4-1c.6-.7 1-1.6 1-2.4 0-.1-.2-.2-.3-.2-.6 0-1 0-1.3 0-.1 0-.2 0-.2.1s.1.1.1.1c.2 0 .4 0 .5.2.2.1.2.3.2.5 0 .6-.3 1.3-.5 1.6-.2-.2-1.5-1.3-1.8-1.7-.8-.9-1.7-1.7-1.7-2.7 0-.9.7-1.2 1.1-1.2.6 0 .9.2 1.1.5s.3.6.3.9c0 .1 0 .2.1.2s.1 0 .1-.2.1-1 .1-1.3c0-.1 0-.2-.2-.3-.3-.1-.7-.2-1.2-.2-1.8 0-2.5 1.1-2.5 1.9 0 .5.1.9.5 1.5-.6.3-1.7 1.2-1.7 2.4 0 .9.7 2.3 2.8 2.3 1.4 0 2.1-.6 2.4-.9.9.7 1.2.8 2.4.8h1.1c.2 0 .3 0 .3-.1 0-.4-.1-.4-.2-.4"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m102.4 45.4c-.2.1-.3.2-.7.2-.3 0-.6 0-.8-.1-.1 0-.1-.1-.1-.2v-3.1c0-.1 0-.1.1-.1h.5c.6 0 1.6.4 1.6 1.9 0 .7-.3 1.2-.6 1.4m4.1 3.6c-.1 0-.2 0-.3 0-.2 0-.6-.1-1.1-.7-.6-.6-1.3-1.6-2.2-2.7 1-.8 1.4-1.5 1.4-2.3 0-.7-.4-1.2-.7-1.4-.5-.4-1.2-.4-1.9-.4-.3 0-1.1 0-1.4 0-.2 0-.9 0-1.4 0-.2 0-.2 0-.2.1s.1.1.2.1h.4c.3.1.4.2.4.6v2.2 1.8c0 .9 0 1.7-.1 2.2 0 .3-.1.5-.3.6-.1 0-.2 0-.4 0-.1 0-.2 0-.2.1s.1.1.2.1h1.3 1.5c.1 0 .2 0 .2-.1s0-.1-.1-.1-.4 0-.5 0c-.3 0-.4-.3-.4-.6 0-.4 0-1.2 0-2.2v-.1c0-.1 0-.1.1-.1h.9c.1 0 .1 0 .2.1s.6.8 1 1.4c.6.8 1 1.3 1.4 1.5.3.1.5.2 1.1.2h1c.1 0 .2 0 .2-.1-.1-.1-.2-.2-.3-.2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m109.6 44.5c0-1.6 0-1.8 0-2.2 0-.3-.1-.5-.4-.6-.1 0-.3 0-.4 0s-.2 0-.2-.1.1-.1.2-.1h.8.6 2.6c.2 0 .4 0 .4-.1h.2c.1 0 .1 0 .1.1s0 .2-.1.7c0 .1 0 .6-.1.7 0 .1 0 .1-.1.1s-.1-.1-.1-.1c0-.1 0-.2-.1-.4s-.2-.3-.7-.4c-.2 0-1.3 0-1.5 0-.1 0-.1 0-.1.1v2.6c0 .1 0 .1.1.1h1.6c.2 0 .4-.1.5-.2s.1-.1.2-.1c0 0 .1 0 .1.1s0 .2-.1.7v.7c0 .1 0 .2-.1.2s-.1 0-.1-.1 0-.2 0-.4c-.1-.2-.2-.4-.6-.4-.2 0-1.2 0-1.5 0 0 0-.1 0-.1.1v.8 1.6c0 .7.2.9 1.2.9.3 0 .7 0 1-.1s.4-.3.5-.8c0-.1 0-.2.1-.2s.1.1.1.2c0 .2-.1.9-.1 1.1-.1.3-.2.3-.6.3-.8 0-1.3 0-1.8 0-.4 0-.8 0-1.1 0-.1 0-.3 0-.6 0-.2 0-.5 0-.7 0-.1 0-.2 0-.2-.1s0-.1.2-.1h.4c.2 0 .3-.3.3-.6 0-.4 0-1.2 0-2.2v-1.8z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m117.8 49.1c-.2-.1-.2-.1-.2-.3 0-.6 0-1.2.1-1.3 0-.2 0-.3.1-.3s.1.1.1.2 0 .3.1.5c.2.8.8 1 1.5 1 .9 0 1.4-.6 1.4-1.2 0-.5-.1-1-1-1.6l-.5-.4c-1.1-.9-1.5-1.6-1.5-2.4 0-1.1.9-1.9 2.4-1.9.7 0 1.1.1 1.4.2.1 0 .1.1.1.1v1.2c0 .2 0 .3-.1.3s-.1-.1-.1-.2 0-.4-.3-.7c-.2-.2-.5-.5-1.1-.5-.8 0-1.2.4-1.2 1.1 0 .5.2.8 1.1 1.5l.3.2c1.2.9 1.7 1.6 1.7 2.6 0 .6-.2 1.3-1 1.8-.5.3-1.1.4-1.6.4-.8 0-1.3-.1-1.7-.3"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "m130 48.9c-2 0-3.1-1.7-3.1-3.8 0-2.6 1.3-3.2 2.5-3.2 1.7 0 3 1.4 3 3.7-.1 2.9-1.7 3.3-2.4 3.3m-.4-7.6c-3.1 0-4.2 2.3-4.2 4 0 1.8 1.2 4 4.1 4 2.6 0 4.2-1.9 4.2-4.2.1-2.3-1.5-3.8-4.1-3.8"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m148.8 42.1h-1.5c-.6 0-.8.1-1 .3-.1.2-.1.3-.2.4 0 .1-.1.1-.1.1-.1 0-.1-.1-.1-.2 0-.2.2-1.1.2-1.2s.1-.2.1-.2c.1 0 .2.1.4.1.3 0 .7.1 1 .1h4.1c.3 0 .6 0 .7-.1.2 0 .2-.1.3-.1s.1.1.1.2v1.2c0 .1 0 .2-.1.2s-.1-.1-.1-.2v-.1c0-.3-.3-.6-1.2-.6h-1.3v4.2c0 .9 0 1.7.1 2.2 0 .3.1.5.4.6h.5c.1 0 .2 0 .2.1s-.1.1-.2.1c-.7 0-1.3 0-1.6 0-.2 0-.9 0-1.3 0-.1 0-.2 0-.2-.1s0-.1.2-.1h.4c.2 0 .3-.3.3-.6.1-.4.1-1.2.1-2.2v-4.1z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "m156.4 49.1c-.2-.1-.2-.1-.2-.3 0-.6 0-1.2.1-1.3 0-.2 0-.3.1-.3s.1.1.1.2 0 .3.1.5c.2.8.8 1 1.5 1 .9 0 1.4-.6 1.4-1.2 0-.5-.2-1-1-1.6l-.5-.4c-1.1-.9-1.5-1.6-1.5-2.4 0-1.1.9-1.9 2.4-1.9.7 0 1.1.1 1.4.2.1 0 .1.1.1.1v1.2c0 .2 0 .3-.1.3s-.1-.1-.1-.2-.1-.4-.3-.7c-.1-.2-.4-.5-1.1-.5-.8 0-1.2.4-1.2 1.1 0 .5.2.8 1.1 1.5l.3.2c1.2.9 1.7 1.6 1.7 2.6 0 .6-.2 1.3-1 1.8-.5.3-1.1.4-1.6.4-.8 0-1.2-.1-1.7-.3"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "m140.7 45.4c-.2.1-.3.2-.7.2-.3 0-.6 0-.8-.1-.1 0-.1-.1-.1-.2v-3.1c0-.1 0-.1.1-.1h.5c.6 0 1.6.4 1.6 1.9 0 .7-.3 1.2-.6 1.4m4.1 3.6c-.1 0-.2 0-.3 0-.2 0-.6-.1-1.1-.7-.6-.6-1.3-1.6-2.2-2.7 1-.8 1.3-1.5 1.3-2.3 0-.7-.4-1.2-.7-1.4-.6-.4-1.2-.4-1.9-.4-.3 0-1.1 0-1.4 0-.2 0-.9 0-1.4 0-.2 0-.2 0-.2.1s.1.1.2.1h.4c.3.1.4.2.4.6v2.2 1.8 2.2c0 .3-.1.5-.3.6-.1 0-.2 0-.4 0-.1 0-.2 0-.2.1s.1.1.2.1h1.3 1.5c.1 0 .2 0 .2-.1s0-.1-.1-.1-.3 0-.5 0c-.3 0-.4-.3-.4-.6-.1-.4-.1-1.2-.1-2.2v-.1c0-.1 0-.1.1-.1h.9c.1 0 .1 0 .2.1s.6.8 1 1.4c.6.8 1 1.3 1.4 1.5.3.1.5.2 1.1.2h1c.1 0 .2 0 .2-.1-.1-.1-.1-.2-.2-.2"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "m163.9 41.9h.8v2.5h.4v-2.5h.8v-.4h-2z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "m169 41.5-1.1 1.4-1.1-1.4h-.3v2.9h.4v-2.1-.1s0 0 0 .1l.9 1.2h.2l.9-1.2v-.1s0 .1 0 .1v2.1h.4v-2.9z"
});

var SvgConrad = function SvgConrad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 185.2 52.8",
    viewBox: "0 0 185.2 52.8",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConrad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "conrad.svg";
export { ForwardRef as ReactComponent };